import React from "react";
const ProdukHukum = React.lazy(() => import('./BiroHukum/ProdukHukum'));
const DetailProdukHukum = React.lazy(() => import('./BiroHukum/DetailProdukHukum'));
const CreateProdukHukum = React.lazy(() => import('./BiroHukum/CreateProdukHukum'));
const SignProdukHukum = React.lazy(() => import('./BiroHukum/SignProdukHukum'));
const OperatorProdukHukum = React.lazy(() => import('./BiroHukum/OperatorProdukHukum'));
const ProdukHukumDirjen = React.lazy(() => import('./Dirjen/ProdukHukum'));
const DetailProdukHukumDirjen = React.lazy(() => import('./Dirjen/DetailProdukHukum'));
const CreateProdukHukumDirjen = React.lazy(() => import('./Dirjen/CreateProdukHukum'));
const SignProdukHukumDirjen = React.lazy(() => import('./Dirjen/SignProdukHukum'));

export const produkHukumConfig = [
    // PH Biro Hukum
    {
        path: '/apps/produk-hukum',
        element: <ProdukHukum />,
        // roleAccess: ['UPLOAD.PRODUK.HUKUM', 'UPLOAD.PRODUK.HUKUM.DIRJEN', 'OPERATOR.NOMOR.PRODUK.HUKUM', 'MONITORING_DIGITAL_SIGN', 'APPROVERS.PRODUK.HUKUM.DIRJEN']
    },
    {
        path: '/apps/produk-hukum/detail/:id',
        element: <DetailProdukHukum />
    },
    {
        path: '/apps/produk-hukum/create',
        element: <CreateProdukHukum />,
        // roleAccess: ['UPLOAD.PRODUK.HUKUM']
    },
    {
        path: '/apps/produk-hukum/create/:id',
        element: <CreateProdukHukum />
    },
    {
        path: '/apps/produk-hukum/sign',
        element: <SignProdukHukum />
    },
    {
        path: '/apps/produk-hukum/operator',
        element: <OperatorProdukHukum />,
        // roleAccess: ['OPERATOR.NOMOR.PRODUK.HUKUM']
    },
    // PH Dirjen
    {
        path: '/apps/produk-hukum-dirjen',
        element: <ProdukHukumDirjen />
    },
    {
        path: '/apps/produk-hukum-dirjen/detail/:id',
        element: <DetailProdukHukumDirjen />
    },
    {
        path: '/apps/produk-hukum-dirjen/create',
        element: <CreateProdukHukumDirjen />,
        // roleAccess: ['UPLOAD.PRODUK.HUKUM.DIRJEN']
    },
    {
        path: '/apps/produk-hukum-dirjen/create/:id',
        element: <CreateProdukHukumDirjen />
    },
    {
        path: '/apps/produk-hukum-dirjen/sign',
        element: <SignProdukHukumDirjen />
    },
];